<template>
  <c-box
    title="Динамика источников трафика"
    shadow
    header-divider
    :loading="loading"
  >
    <div id="tsopm-g">
      <c-line-chart
        v-if="!loading && data.length"
        :chart-data="chartData"
        :options="chartOptions"
        :height="150"
      />
    </div>
    <no-data v-if="!loading && !data.length" />
  </c-box>
</template>

<script>
import CBox from '../../../../../../../resources/js/components/ui/CBox.vue'
import NoData from '../../../../../../../resources/js/components/NoData.vue'
import CLineChart from '../../../../../../../resources/js/components/ui/CLineChart.vue'
import sengine from '../../../../../../../resources/js/mixins/sengine'
import diagramColors from '../../../../../../../resources/js/mixins/diagramColors'

export default {
  name: 'TrafficSourcesPerMonth',
  components: { CLineChart, NoData, CBox },
  mixins: [sengine, diagramColors],
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    data: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      chartOptions: {
        scales: {
          xAxes: [{
            gridLines: {
              display: false,
              drawBorder: false
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: 'Визиты'
            }
          }]
        },
        elements: {
          point: {
            radius: 3
          }
        },
        legend: {
          position: 'bottom',
          labels: {
            boxWidth: 7,
            fontStyle: 'bold',
            fontColor: '#282828',
            usePointStyle: true
          }
        },
        plugins: {
          datalabels: {
            display: false
          }
        }
      }
    }
  },
  computed: {
    chartData () {
      const dates = []

      for (const month in this.data[0]) {
        if (month === 'Источник') {
          continue
        }

        dates.push(month)
      }

      return {
        labels: dates,
        datasets: this.data.map((item, index) => {
          const visits = []

          for (const d in item) {
            if (Number.isInteger(item[d])) {
              visits.push(item[d])
            }
          }

          return {
            label: item.Источник,
            data: visits,
            fill: false,
            borderColor: this.getNextDiagramColor(index),
            lineTension: 0
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  #tsopm-g {
    min-width: 890px;
  }
</style>
